import { app } from '../../../../bootstrap/core';
import { downloadBalanceListState } from './downloadBalanceList.state';
import { downloadBalanceListComponent } from './downloadBalanceList.component';

app.config(downloadBalanceListState);
app.component(downloadBalanceListComponent.name, downloadBalanceListComponent);
